import { Box, Divider, Grid, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import cross from '../Assets/Images/AboutUs/cross.png'
import work from '../Assets/Images/AboutUs/hww.png'
import RoundAppLogo from '../Components/RoundedAppLogo'
import TeamMember from '../Assets/Images/AboutUs/TeamMember.png'
import LetsTalk from '../Components/LetsTalk'
import AOS from "aos";
import "aos/dist/aos.css";

function AboutUs() {
    const features = [
        { title: "Discovery & Strategy", discription: "We start by deeply understanding your business goals, users, and challenges. Through workshops and research, we define a clear roadmap that aligns technology with real-world outcomes." },
        { title: "Design & Architecture", discription: "Our team crafts intuitive user experiences and robust system architectures. Every decision is guided by scalability, performance, and long-term sustainability." },
        { title: "Development & Testing", discription: "We build using modern technologies and best practices, with continuous testing to ensure reliability, security, and high performance across all platforms." },
        { title: "Launch & Continuous Improvement", discription: "After deployment, we monitor, optimize, and evolve your product using real user data—ensuring it stays relevant, efficient, and ready to scale." },
    ]
    const Team = [
        { name: 'Ankit Patel', position: "Founder & CEO", image: '/Images/Team/AnkitPatel2.png' },
        { name: 'Krupa Patel', position: "Chief Operating Officer", image: '/Images/Team/KrupaPatel2.png' },
        { name: 'Ben Dillon', position: "Head of Sales", image: '/Images/Team/Ben2.png' },
        { name: 'Steven Parthimos', position: "Head of Marketing", image: '/Images/Team/StevenParthimos2.png' },
        { name: 'Sagar Sojitra', position: "DevOps Lead", image: '/Images/Team/SagarSojitra2.png' },
        { name: 'Darshan Sanandiya', position: "Head of Technology", image: '/Images/Team/DarshanSanandiya2.png' },
        { name: 'Viplav Mistry', position: "Lead UX Designer", image: '/Images/Team/ViplavMistry2.png' },
        { name: 'Ravi Patel', position: "Frontend Developer", image: '/Images/Team/RaviPatel3.png' },
        { name: 'Raj Patel', position: "Flutter Developer", image: '/Images/Team/RajPatel2.png' },
        { name: 'Avadh Sapariya', position: "Flutter Developer", image: '/Images/Team/AvadhSapariya2.png' },
        { name: 'Nayan Kukadiya', position: "Senior Android Developer", image: '/Images/Team/NayanKukadiya2.png' },
        { name: 'Keval Shingrakhiya', position: "Senior iOS Developer", image: '/Images/Team/keval.png' },
        { name: 'Rohit Parsana', position: "Senior iOS Developer", image: '/Images/Team/RohitParsana2.png' },
        { name: 'Jyoti Paghdal', position: "Sr. Full Stack developer", image: '/Images/Team/JyotiPagdhal2.png' },
        { name: 'Rohit Rana', position: "Sr. Full Stack Developer", image: '/Images/Team/RohitRana2.png' },
        { name: 'Vansh Raval', position: "Full Stack Developer", image: '/Images/Team/VanshRaval2.png' },
        { name: 'Vivek Bharwani', position: "Full Stack Software Engineer", image: '/Images/Team/Vivek.png' },
        { name: 'Anand Purohit', position: "Sr. Backend Developer", image: '/Images/Team/AnandPurohit2.png' },
        { name: 'Priyank Sanghavi', position: "Senior Software Engineer",image:'/Images/Team/priyank.png' },
        { name: 'Vijay Chauhan', position: "Senior Software Engineer",image:'/Images/Team/vijaybhai.png' },
        { name: 'Dharmik Hapaliya', position: "Backend Developer", image: '/Images/Team/DharmikHapaliya2.png' },
        { name: 'Shifa Pathan', position: "Backend Developer", image: '/Images/Team/ShifaPathan2.png' },
        { name: 'Farhan Vagadiya', position: "Senior QA Engineer", image: '/Images/Team/farhan.png' },
        { name: 'Yash Mistry', position: "Quality Assurance", image: '/Images/Team/YashMistry2.png' },
        // { name: 'Priya Chauhan', position: "Quality Assurance", image: '/Images/Team/PriyaChauhan2.png' },
    ]

    useEffect(() => {
        AOS.init({
            duration: 1000, // animation duration
            once: true,     // animation happens only once
        });
    }, []);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, [])


    return (
        <Box mt={{ xs: 8, md: 4, lg: 5 }} className='aboutus'>
            {/* -------------------------------------------- Title -------------------------------------------- */}
            <Grid container>
                <Grid size={{ xs: 12, lg: 8 }}>
                    <Typography
                            component="h1"
                            variant="h1"
                            sx={{
                              position: 'absolute',
                              width: 1,
                              height: 1,
                              padding: 0,
                              margin: -1,
                              overflow: 'hidden',
                              clip: 'rect(0, 0, 0, 0)',
                              whiteSpace: 'nowrap',
                              border: 0
                            }}
                          >
                            We’re creative engine behind Melbourne’s most ambitious digital transformations. By fusing top-tier mobile & web development with bespoke UI/UX & advanced AI/IoT, we build the future.
                          </Typography>
                    <Typography data-aos="fade-up" className='fs-42 text-color-main' fontWeight={500}>
                        We’re <span className='text-light-main'> creative engine behind Melbourne’s most ambitious digital transformations. </span> By fusing top-tier mobile & web development with bespoke UI/UX & advanced AI/IoT, we build the future.</Typography>
                </Grid>
            </Grid>

            {/* -------------------------------------------- Company Details -------------------------------------------- */}
            <Grid container spacing={2} mt={{ xs: 2, md: 3, lg: 5 }}>
                <Grid data-aos="fade-up" size={{ xs: 12, md: 4 }} position={'relative'} className='bg-main py-2 border-10'>
                    <Box className='cross' src={cross} component={'img'} maxHeight={'80px'} />
                    <Box>
                        <Typography mb={1} className='fs-72 fw-bold text-center'
                            sx={{
                                color: "transparent",
                                WebkitTextStroke: "2px var(--primary-dark-color)"
                            }}
                        >11</Typography>
                        <Typography className='fs-18 text-color-main text-center'>Years of Experience</Typography>
                    </Box>
                </Grid>
                <Grid data-aos="fade-up" size={{ xs: 12, md: 4 }} position={'relative'} className='bg-main py-2 border-10'>
                    <Box className='cross' src={cross} component={'img'} maxHeight={'80px'} />
                    <Box>
                        <Typography mb={1} className='fs-72 fw-bold text-center'
                            sx={{
                                color: "transparent",
                                WebkitTextStroke: "2px var(--primary-dark-color)"
                            }}
                        >68</Typography>
                        <Typography className='fs-18 text-color-main text-center'>Happy Clients</Typography>
                    </Box>
                </Grid>
                <Grid data-aos="fade-up" size={{ xs: 12, md: 4 }} position={'relative'} className='bg-main py-2 border-10'>
                    <Box className='cross' src={cross} component={'img'} maxHeight={'80px'} />
                    <Box>
                        <Typography mb={1} className='fs-72 fw-bold text-center'
                            sx={{
                                color: "transparent",
                                WebkitTextStroke: "2px var(--primary-dark-color)"
                            }}
                        >143</Typography>
                        <Typography className='fs-18 text-color-main text-center'>Projects Completed</Typography>
                    </Box>
                </Grid>
            </Grid>

            {/* -------------------------------------------- How We Work -------------------------------------------- */}
            <Typography data-aos="fade-up" gutterBottom mt={{ xs: 2, md: 3, lg: 5 }} className='fs-52 text-color-main' fontWeight={500}>How we work</Typography>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 6, lg: 8 }}>
                    <Typography data-aos="fade-up" className='fs-16 text-grey mb-3' width={{ xs: "100%", md: "75%", lg: '50%' }}>
                        At App Gallery, we bridge the gap between ideas and execution through a structured, transparent, and collaborative approach.
                    </Typography>
                    <Typography data-aos="fade-up" className='fs-16 text-grey' width={{ xs: "100%", md: "75%", lg: '50%' }}>
                        We begin by understanding your business goals, challenges, and users. From there, we design intuitive solutions, build scalable systems, and continuously refine them based on real-world performance and feedback.
                    </Typography>
                    <Typography data-aos="fade-up" className='fs-16 text-grey' width={{ xs: "100%", md: "75%", lg: '50%' }}>
                        Our process is driven by precision and accountability—ensuring every product we deliver is secure, high-performing, and built to scale. We combine modern technologies with proven engineering practices to reduce complexity and accelerate time to market.
                    </Typography>
                    <Typography data-aos="fade-up" className='fs-16 text-grey' width={{ xs: "100%", md: "75%", lg: '50%' }}>
                        More than just development, we act as a long-term technology partner—helping you adapt, evolve, and grow in an ever-changing digital landscape.                    </Typography>
                </Grid>
                <Grid data-aos="fade-left" size={{ xs: 12, md: 6, lg: 4 }}>
                    <Box position={'relative'} width={'fit-content'} height={'fit-content'}>
                        <Box component={'img'} className='border-10' src={work} maxHeight={'300px'} />
                        <Box position={'absolute'} right={"-10%"} top={"-15%"}>
                            <RoundAppLogo />
                        </Box>
                    </Box>
                </Grid>
            </Grid>

            {/* -------------------------------------------- Features -------------------------------------------- */}

            <Box mt={{ xs: 2, md: 3, lg: 5 }} className='bg-light-main'>
                {features?.map((item, index) => (
                    <Grid className='p-3 bg-light-main mb-2' spacing={{ xs: 2, lg: 20 }} container >
                        <Grid size={'auto'}>
                            <Typography data-aos="fade-up" className='fs-48 fw-bold text-light-main'>0{index + 1}</Typography>
                            <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main' ml={{ lg: 7 }}>{item?.title?.split("&")[0]} & <br/> {item?.title?.split("&")[1]}</Typography>
                        </Grid>
                        <Grid size={{ xs: 12, md: 'grow' }} borderBottom={'1px solid var(--primary-dark-light-color)'} alignItems={{ xs: "start", md: "end" }} className='d-flex  pb-3'>
                            <Typography data-aos="fade-up" width={{ xs: "100%", md: "50%" }} ml={{ xs: 0, md: "auto" }} className='fs-16 text-grey'>{item?.discription}</Typography>
                        </Grid>
                    </Grid>
                ))}
            </Box>

            {/* -------------------------------------------- Our Team -------------------------------------------- */}
            <Typography data-aos="fade-up" gutterBottom mt={{ xs: 2, md: 3, lg: 5 }} className='fs-52 text-color-main' fontWeight={500}>Meet The Expert Team</Typography>
            <Grid container spacing={2}>
                {Team?.map((item, index) => (
                    <Grid data-aos="zoom-in" key={index} size={{ xs: 12, sm: 4, lg: 3, xl:2 }}>
                        <Box component={'img'} className='border-10' src={item?.image} width={'100%'} height={'295.98px'} sx={{ objectFit: 'cover', background:'url(/Images/Team/TeamBg.png)', backgroundPosition:'center center', backgroundSize:'cover' }}></Box>
                        <Typography className='fs-20 fw-bold text-color-main'>{item?.name}</Typography>
                        <Typography className='fs-14  text-grey'>{item?.position}</Typography>
                    </Grid>
                ))}
            </Grid>

            <Box className='mt-5'>
                <LetsTalk />
            </Box>

        </Box>
    )
}

export default AboutUs
